import React from 'react';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@/components/Tooltip';
import { getEndpointWithParams } from '@/routes/config';
import { TechnicalChallengeInterviewReviewers } from '@/types/api';
import { Paths } from '@/types/routes';
import * as Styles from './AsignedReviewersList.styles';

interface AsignedReviewersListProps {
  reviewers: TechnicalChallengeInterviewReviewers[];
}

const AsignedReviewersList: React.FC<AsignedReviewersListProps> = ({ reviewers }) => {
  const navigate = useNavigate();

  if (!reviewers?.length) {
    return <Styles.NoReviewersText>No reviewers</Styles.NoReviewersText>;
  }

  const handleReviewerClick = (reviewerId: string): void => {
    const reviewerLink = getEndpointWithParams(Paths.CANDIDATE_DETAILS, {
      id: reviewerId,
    });
    navigate(reviewerLink);
  };

  return (
    <Styles.ReviewersContainer>
      {reviewers.map((reviewer, index) => {
        const { person } = reviewer.interviewReviewer;

        return (
          <Tooltip
            key={reviewer.id}
            label={`${person.firstName || ''} ${person.lastName || ''}`}
            placement="bottom"
          >
            <Styles.ReviewerAvatar
              size={28}
              pictureUrl={person.pictureUrl || ''}
              firstName={person.firstName}
              lastName={person.lastName || ''}
              index={index}
              total={reviewers.length}
              onClick={() => handleReviewerClick(person.id)}
            />
          </Tooltip>
        );
      })}
    </Styles.ReviewersContainer>
  );
};

export default AsignedReviewersList;
